import React, {Component} from "react";
import companyProfile from '../../../../../assets/img/companyProfile.png';
import "./CompanyProfile.css";
import './Beginners.css';
import companyProfile2 from '../../../../../assets/img/companyProfile-2.png'
import MetaTags from "react-meta-tags";

class CompanyProfile extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);

    }

    render() {
        return (
            <div className="resp-company-profile">
                <MetaTags>
                    <title>運営会社｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="運営会社｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="運営会社｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div-company">

                    <div className="">
                        <img src={companyProfile} className="img-company-profile"/>
                    </div>
                    <div className="spacer"></div>
                   <div className="company-profile-content-resp">

                       <div className="row">
                           {/*<div className="company-space-txt">*/}
                           {/*<text id="company-profile-title">運営会社</text>*/}
                           {/*</div>*/}
                           <div>

                                   <h3 className="company-profile-page-heading">
                                       運営会社
                                   </h3>
                           </div>
                       </div>
                       <div className="spacer"></div>

                       {/*<p className='all-content-font-size company-space-txt'> その「アイデアをカタチに！」という経営理念を胸に*/}
                       {/*</p>*/}
                       {/*<p className='all-content-font-size company-space-txt'>私たちはネット上でみなさまのモノづくり環境を継続的に支え、持続的な競争力を*/}
                       {/*提供し続ける存在を目指します。*/}
                       {/*</p>*/}
                       {/*<p className='all-content-font-size company-space-txt'>インターネットを通じてあらゆるモノやサービスを連携させて、モノづくりのパートナー*/}
                       {/*</p>*/}
                       {/*<p className='all-content-font-size company-space-txt'> としての存在を確立し、その関係を世界の多くの企業と結び、広げていくことを*/}
                       {/*常に考え、挑戦し続けていきたいと思います。*/}
                       {/*</p>*/}
                       {/*<p className='all-content-font-size company-space-txt'> そうすることで少しずつ、着実に会社としての成長を図っていきたいと思います。*/}
                       {/*</p>*/}
                       {/*<div className="spacer"></div>*/}

                       {/*<div className="row">*/}
                       {/*<div className="col-md-2 company-sub company-space-txt">会社名</div>*/}
                       {/*<div className="col-md-6 company-txt">利全香港有限公司</div>*/}
                       {/*<div className="col-md-4 company-txt"></div>*/}
                       {/*</div>*/}
                       {/*<div className="row">*/}
                       {/*<div className="col-md-2 company-sub no-padding-right company-space-txt">本社所在地</div>*/}
                       {/*<div className="col-md-6 company-txt">香港九龍尖沙咀金馬倫道5號太興廣場9樓904室</div>*/}
                       {/*<div className="col-md-4 company-txt"></div>*/}

                       {/*</div>*/}
                       {/*<div className="row">*/}
                       {/*<div className="col-md-2 company-sub company-space-txt">設立</div>*/}
                       {/*<div className="col-md-6 company-txt">2006 年 4 月 20 日</div>*/}
                       {/*<div className="col-md-4 company-txt"></div>*/}

                       {/*</div>*/}
                       {/*<div className="row">*/}
                       {/*<div className="col-md-2 company-sub company-space-txt">代表者</div>*/}
                       {/*<div className="col-md-6 company-txt">代表取締役 谷本了一</div>*/}
                       {/*<div className="col-md-4 company-txt"></div>*/}

                       {/*</div>*/}

                       <div className="row">
                           <div className="responsive-fontsize padding-company-prof-top-left">

                               <div className="col-md-3 no-padding resp-company-profile-headings company-profile-height"> 社名</div>
                               <div className="col-md-9 left-margin-company-prof company-profile-height">RIZEN HK LIMITED</div>
                               <div className="col-md-3 no-padding resp-company-profile-headings company-profile-height"> 代表取締役</div>
                               <div className="col-md-9 left-margin-company-prof company-profile-height">谷本了一</div>
                               <div className="col-md-3 no-padding resp-company-profile-headings company-profile-height"> メールアドレス</div>
                               <div className="col-md-9 left-margin-company-prof company-profile-height">service@kitcutlabo.com</div>
                               <div className="col-md-3 no-padding resp-company-profile-headings company-profile-height"> 拠点</div>
                               <div className="col-md-9 left-margin-company-prof padding-top-company-profile">
                                   <div className="company-profile-height-remove"> 本社</div>
                                   <div className="company-profile-height-remove"> 香港九龍尖沙咀金馬倫道 5 號太興廣場 9 樓 904 室</div>
                                   {/*<div > 関西事務所</div>*/}
                                   {/*<div> 大阪市中央区本町橋 5-14 6F</div>*/}

                               </div>
                               <div className="col-md-3 "> </div>

                               <div className="col-md-9 left-margin-company-prof padding-top-company-profile  ">
                                   {/*<div> 香港本社</div>*/}
                                   {/*<div> 香港九龍尖沙咀金馬倫道 5 號太興廣場 9 樓 904 室</div>*/}
                                   <div  className="company-profile-height-remove"> 大阪事務所</div>
                                   <div className="company-profile-height-remove"> 大阪市中央区本町橋5-14　OZIビル6F</div>

                               </div>


                               <div>

                                   <h3 className="secondary-heading-company-profile-resp">代表挨拶</h3>
                                   <div className="spacer"></div>

                                   <div className="col-md-3 remove-company-profile-left">
                                       <div className="profile-image-resp">
                                           <img src={companyProfile2} className="set-company-prof-img-size"/>
                                       </div>
                                       <div className="image-below-fontsize">
                                           代表取締役 谷本了一
                                       </div>
                                   </div>
                                   <div className="col-md-9 no-padding font-size-16 responsive-fontsize company-profile-content-para-resp">
                                       <div>
                                           弊社が、これまで培ってきた電子部材の海外調達業務で
                                           実際の製品開発のプロセスや生産工場との連携の中で起
                                           こったいろいろな出来事・課題、そこから得たノウハウ
                                           を日本人による日本人にしかできないモノづくりのため
                                           に役立てたいという志を持って「KITCUT PCB」はスタートしました。
                                       </div>
                                       <div>
                                           そんな思いを少しでも感じ取っていただけたら幸いです。
                                       </div>
                                       <div className="spacer"></div>

                                       <div>
                                           私たちはネット上でみなさまの製品開発に必要な” キット”
                                           を継続的に支え持続的な競争力とグローバルな開発環境を
                                           提供し続けられるよう社員一同精一杯尽力して参ります。
                                       </div>
                                   </div>


                               </div>
                           </div>
                       </div>
                       <div className="row">


                       </div>
                   </div>


                </div>
            </div>

            // </div>
        );
    }
}

export default CompanyProfile;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/CompanyProfile.js